export const SWITCH_STATES = {
  ON: 'ON',
  OFF: 'OFF',
  PAUSE: 'PAUSE',
};
